import { useQueryParam, StringParam } from "use-query-params";

export const useSurveyType = () => {
  const [surveyType, setSurveyType] = useQueryParam("surveyType", StringParam);
  //@ts-ignore
  return [surveyType, setSurveyType] as const;
};
